import * as React from "react";
import { makeStyles, Avatar } from "@fluentui/react-components";
import { FaPaste } from "react-icons/fa";
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'

// Define brand color
const brandColor = "#921784";

// --- Styles ---
const useStyles = makeStyles({
  messageContainerBase: {
    display: "flex",
    marginBottom: "10px",
    maxWidth: "100%",
    width: 'fit-content',
  },
  alignStart: {
    width: "100%"
  },
  alignEnd: {
    alignSelf: "flex-end",
  },
  avatar: {
    marginRight: "8px",
    marginLeft: "8px",
    flexShrink: 0,
    color: brandColor,
    alignSelf: 'flex-end',
  },
  messageBubble: {
    borderRadius: "10px",
    padding: ["8px", "12px"],
    wordBreak: "break-word",
    whiteSpace: "pre-wrap",
  },
  userMessageBubble: {
    backgroundColor: brandColor,
    color: "#ffffff",
    borderTopRightRadius: "0px",
  },
  botMessageBubble: {
     backgroundColor: "#FFF4FF",
     borderTopLeftRadius: "0px",
     border: ["1px", "solid", brandColor],
     color: "#3b3a39",
  },
  alignIcon: {
    color: "#3b3a39"
  }
});

const useMarkDownStyles = makeStyles({
  root: {
    "& h2": {
      fontSize: "1.5em",
      margin: "12px 0",
    },
    "& h3": {
      fontSize: "1.2em",
      margin: "12px 0",
    },
    "& table": {
      borderCollapse: "collapse",
      width: "100%",
      margin: "6px 0",
    },
    "& th, & td": {
      border: "1px solid #921784",
      padding: "8px",
      textAlign: "left",
    },
    "& th": {
      backgroundColor: "#f8e6f4",
      color: "#921784",
      fontWeight: "bold",
    },
    "& hr": {
      border: "none",
      borderTop: "2px solid #921784",
      margin: "6px 0",
    },
    "& ol, & ul": {
      margin: "6px 0",
      paddingLeft: "20px",
    },
    "& p": {
      margin: "6px 0",
    },
    "& a": {
      textDecoration: "underline",
    },
  },
});

// --- Props Interface ---
export interface ChatMessageProps {
  sender: "user" | "bot";
  text: string;
  copyAndPaste: (text: string) => void;
}

// --- Component ChatMessage ---
const ChatMessage: React.FC<ChatMessageProps> = ({ sender, text, copyAndPaste }) => {
  
  const styles = useStyles();
  const markstyles = useMarkDownStyles();
  const markdownRef = React.useRef(null);
  
  const isUser = sender === "user";

  const alignmentClass = isUser ? styles.alignEnd : styles.alignStart;

  const [newTxt, setNexTxt] = React.useState<string>('');

  React.useEffect(() => {
    setNexTxt(text);
  }, [text]);
  
  return (
    <div className={`${styles.messageContainerBase} ${alignmentClass}`}>
      <div className={`${styles.messageBubble} ${isUser ? styles.userMessageBubble : styles.botMessageBubble}`}>
         <div ref={markdownRef} className={`${markstyles.root}`} style={{ textAlign: 'justify' }}> 
          <ReactMarkdown remarkPlugins={[remarkGfm]} children={ newTxt } />
        </div>
        {!isUser && 
        <div>
          <hr />
          <Avatar onClick={() => copyAndPaste(markdownRef.current.innerHTML)} icon={<FaPaste />} color="neutral"/>
        </div>
        }
      </div>
    </div>
  );
};

export default ChatMessage;
